import { render } from "./ShoppingListXs.vue?vue&type=template&id=48a31654"
import script from "./ShoppingListXs.vue?vue&type=script&lang=js"
export * from "./ShoppingListXs.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__